/*
 * @Descripttion: file content
 * @Author: zc
 * @Date: 2020-05-26 13:24:22
 * @LastEditors: zc
 * @LastEditTime: 2020-12-04 11:02:13
 */
import { service, formService } from '@/data/index'; // 获取有权限的系统列表

export function getAppList(data) {
  return service.get('getAppList', data);
} // 获取任教信息

export function getTeachingInfo(data) {
  return service.get('school/teacher/getTeachingInfo', data);
} // 保存任教信息

export function updateTeachingInfo(data) {
  return service.post('school/teacher/updateTeachingInfo', data);
}
/**
 * @function importTeacherFile 教师信息批量导入
 * @returns {*}
 */

export function logoOut() {
  return service({
    url: 'logout',
    method: 'get'
  });
}
export function getTeacherInfo() {
  return service.get('school/teacher/getInfo');
}
export function getSysDirectory(data) {
  return service.get('dictionaries/findDictionariesByCode', data);
}
export function saveTeacherInfo(data) {
  return service.get('school/teacher/saveInfo', data);
}
export function checkClassNum(data) {
  return service.get('school/class/checkClassNum', data);
}
export function getGradeList() {
  return service.get('school/grade/list');
}
export function getClassList(data) {
  return service.get('school/class/listAll', data);
}
export function getSubjectList(data) {
  return service.get('school/schoolSubject/list', data);
}
export function saveClassTeacher(data) {
  return service.post('school/class/saveClassTeacher', data);
}
export function jumpUpdate() {
  return service.get('jumpUpdate');
}
export function updatePassword(data) {
  return service.post('updatePassword', data);
}
export function changePassword(data) {
  return formService.post('userCenter/changePassword', data);
}
/**
 * @function getMasterCenterDetail 获取校长登录后个人信息
 * @returns {*}
 */

export function getMasterCenterDetail() {
  return service.post('/org/person/detailSelf');
}
/**
 * @function editMasterInfo 校长登录，修改本人信息
 * @returns {*}
 */

export function editMasterInfo() {
  return service.post('/org/person/detailSelf');
}
/**
 * 查看教师
 * @param data
 */

export function getOneTeacherFn(data) {
  return formService.post('school/teacher/teacherInfo', data);
}
/**
 * 更新教师信息
 * @param data
 */

export function teacherUpdateInfo(data) {
  return service.post('school/teacher/updateInfo', data);
}
/**
 * 补全信息第二步信息回显
 * @param data
 */

export function teacherGetRelation(data) {
  return service.post('school/teacher/getRelation', data);
}